<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter" id="abbrev">
<h1 class="ctfm"><a class="page" id="pvi"></a><a class="page" id="pvii"></a><a class="xref" href="#/chiKrinsky0005#toc"> Abbreviations</a></h1>
<table>
<tbody><tr>
<td>
<p class="td"><abbr>APSW</abbr> </p>
</td>
<td>
<p class="td">Associate Park Service Worker</p>
</td>
</tr>
<tr>
<td>
<p class="td"><abbr>APRM</abbr> </p>
</td>
<td>
<p class="td">Associate Parks and Recreation Manager</p>
</td>
</tr>
<tr>
<td>
<p class="td"><abbr>CPW</abbr> </p>
</td>
<td>
<p class="td">City Park Worker</p>
</td>
</tr>
<tr>
<td>
<p class="td"><abbr>CSA</abbr> </p>
</td>
<td>
<p class="td">City Seasonal Aide</p>
</td>
</tr>
<tr>
<td>
<p class="td"><abbr>DPR</abbr> </p>
</td>
<td>
<p class="td">Department of Parks and Recreation</p>
</td>
</tr>
<tr>
<td>
<p class="td"><abbr>JTP</abbr> </p>
</td>
<td>
<p class="td">Job Training Participant</p>
</td>
</tr>
<tr>
<td>
<p class="td"><abbr>PEP</abbr> </p>
</td>
<td>
<p class="td">Parks Enforcement Officer</p>
</td>
</tr>
<tr>
<td>
<p class="td"><abbr>P4P</abbr> </p>
</td>
<td>
<p class="td">Partnerships for Parks</p>
</td>
</tr>
<tr>
<td>
<p class="td"><abbr>PIP</abbr> </p>
</td>
<td>
<p class="td">Parks Inspection Program</p>
</td>
</tr>
<tr>
<td>
<p class="td"><abbr>POP</abbr> </p>
</td>
<td>
<p class="td">Parks Opportunity Program</p>
</td>
</tr>
<tr>
<td>
<p class="td"><abbr>PPS</abbr> </p>
</td>
<td>
<p class="td">Principal Park Supervisor</p>
</td>
</tr>
<tr>
<td>
<p class="td"><abbr>PS1</abbr> </p>
</td>
<td>
<p class="td">Park Supervisor, Level 1</p>
</td>
</tr>
<tr>
<td>
<p class="td"><abbr>PS2</abbr> </p>
</td>
<td>
<p class="td">Park Supervisor, Level 2</p>
</td>
</tr>
<tr>
<td>
<p class="td"><abbr>SYEP</abbr> </p>
</td>
<td>
<p class="td">Summer Youth Employment Program</p>
</td>
</tr>
<tr>
<td>
<p class="td"><abbr>WEP</abbr> </p>
</td>
<td>
<p class="td">Work Experience Program</p>
</td>
</tr>
</tbody></table>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chi-Krinsky-0006.vue?0ddf3a76